'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('./Page.less');

// For Modernizr detects html-class
Modernizr.touchevents;

module.exports = Backbone.View.extend({

	el: 'body',

    events: {

    },


    initialize: function(options) {
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/pages/Page/Page.js
 ** module id = 11
 ** module chunks = 0
 **/